import axios from 'axios';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { fetchRefreshToken, fetchProfileRefreshToken } from '../components/api/api';
import { getTokens, setTokenFor, getAccessToken } from './tokenStore';

let isRefreshing = false;
let failedQueue = [];

const isDevelopment = window.location.hostname === 'localhost';
const cookieDomain = isDevelopment
  ? process.env.REACT_APP_COOKIE_DOMAIN || '.localhost'
  : process.env.REACT_APP_COOKIE_DOMAIN || '.ilaws.net';


const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

export const getCookieOptions = () => {
  const options = {
    expires: 365 * 100,
    secure: process.env.REACT_APP_COOKIE_SECURE === 'true',
    sameSite: process.env.REACT_APP_COOKIE_SAMESITE || 'strict',
  };

  if (process.env.REACT_APP_COOKIE_DOMAIN) {
    options.domain = process.env.REACT_APP_COOKIE_DOMAIN;
  }

  return options;
};

// console.log(
//   'token axiosInterceptor ----- >',
//   Cookies.get('token', getCookieOptions())
// );

const refreshAccessToken = async (originalRequestUrl) => {
  try {
    const tokens = getTokens();
    const isProfileCall = originalRequestUrl?.startsWith(process.env.REACT_APP_BASE_URL_PROFILE);
    // Always attempt to refresh both, to keep them in sync
    // Main token refresh
    if (tokens.main?.accessToken && tokens.main?.refreshToken) {
      const decodedMain = jwtDecode(tokens.main.accessToken);
      const refreshedMain = await fetchRefreshToken(tokens.main, decodedMain.email || decodedMain.userName);
      if (refreshedMain) setTokenFor('main', refreshedMain);
    }
    // Profile token refresh
    if (tokens.profile?.accessToken && tokens.profile?.refreshToken) {
      const decodedProf = jwtDecode(tokens.profile.accessToken);
      // ارسال تنها مقدار رفرش‌توکن جهت سازگاری با API
      const refreshedProfile = await fetchProfileRefreshToken(
        tokens.profile.refreshToken,
        decodedProf.userName || decodedProf.email
      );
      if (refreshedProfile) {
        setTokenFor('profile', refreshedProfile);
        // به‌روزرسانی کوکی legacy برای هدر: { data: {...} }
        try {
          const legacy = refreshedProfile?.data ? refreshedProfile.data : refreshedProfile;
          Cookies.set('token', JSON.stringify({ data: legacy }), getCookieOptions());
        } catch {}
      }
    }

    // Return the appropriate token based on the original request URL
    const system = isProfileCall ? 'profile' : 'main';
    return getAccessToken(system);
  } catch (error) {
    console.error('Error refreshing access token:', error);

    // Clear everything and redirect to login
    Cookies.remove('tokens', getCookieOptions());
    localStorage.removeItem('tokenLogin');
    localStorage.clear();

    window.location.href = '/login';
    throw error;
  }
};

export const setupAxiosInterceptors = () => {
  // Response interceptor
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // Check if error is 401 and we haven't retried yet
      if (error.response?.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          // If already refreshing, queue this request
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers['Authorization'] = `Bearer ${token}`;
              return axios(originalRequest);
            })
            .catch((err) => {
              return Promise.reject(err);
            });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        return new Promise((resolve, reject) => {
          refreshAccessToken(originalRequest.url)
            .then((newAccessToken) => {
              // Update the failed request with new token
              originalRequest.headers[
                'Authorization'
              ] = `Bearer ${newAccessToken}`;

              // Process all queued requests
              processQueue(null, newAccessToken);

              // Retry the original request
              resolve(axios(originalRequest));
            })
            .catch((err) => {
              processQueue(err, null);
              reject(err);
            })
            .finally(() => {
              isRefreshing = false;
            });
        });
      }

      return Promise.reject(error);
    }
  );

  console.log('✅ Axios interceptors setup completed');
};

export default setupAxiosInterceptors;
